import React, { Component } from "react";
import PT from "prop-types";
import { multiLanguage } from "../../hoc";
import { Modal } from "../../components";
import { EbrochureDownload } from "../../containers";
import { assetsPath } from "../../utils";

@multiLanguage()
export default class Ebrochure extends Component {
  static propTypes = {
    t: PT.func,
  };
  static defaultProps = {
    t: () => {},
  };
  state = {
    showDownloadModal: false,
  };
  handleOpenDownload = () => {
    this.setState({
      showDownloadModal: true,
    });
  };
  handleCloseModal = () => {
    this.setState({
      showDownloadModal: false,
    });
  };
  handleEbrochureDownloaded = () => {
    this.setState({
      showDownloadModal: false,
    });
  };
  render() {
    const { page, t, currentLanguage } = this.props;
    const { showDownloadModal } = this.state;
    console.log("assetsPath(page) ebrochure >>>> ", this.props);
    return (
      <div className="section-ebrochure container">
        <div className="section-ebrochure-image">
          {page === "phuket-laguna-park-2" ? (
            <img
              className="section-ebrochure-image"
              src={`${assetsPath(
                page
              )}/images/e-brochure/cover-new-${currentLanguage}.jpg`}
              alt=""
            />
          ) : (
            <img
              className="section-ebrochure-image"
              src={`${assetsPath(
                page
              )}/images/e-brochure/cover-${currentLanguage}.jpg`}
              alt=""
            />
          )}
        </div>
        <div>
          <div className="section-ebrochure-containbtn">
            <h2 style={{ margin: 20 }}>{t("E-Brochure")}</h2>
            <div
              className="section-ebrochure-btn _df_button"
              // className="section-ebrochure-btn"
              source={`${assetsPath(page)}/pdf/brochure/${currentLanguage}.pdf`}
            >
              <div className="ebrochure-text">{t("View Online")}</div>
            </div>
            <div
              className="section-ebrochure-btn"
              onClick={() => this.handleOpenDownload()}
            >
              <div className="ebrochure-text">{t("Download")}</div>
            </div>
          </div>
        </div>
        {showDownloadModal && (
          <Modal name="ebrochure-modal" onCancel={this.handleCloseModal}>
            <EbrochureDownload
              t={this.props.t}
              location={this.props.location}
              project={this.props.project}
              language={this.props.currentLanguage}
              onSubmit={this.handleEbrochureDownloaded}
            />
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/Ebrochure.js